import { ReactElement } from 'react';

import { Translate } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../translations';

import { StyledRolesText } from './PractitionerResourceLabelContent.styled';

export type PractitionerAvailableProfessionType =
   | 'ADDICTION_PSYCHOTHERAPY_SPECIALIST'
   | 'DIETITIAN'
   | 'OTHER'
   | 'PSYCHOLOGIST'
   | 'PSYCHOTHERAPIST';

type ParamedicProfessionProps = {
   profession: string;
};

export const ParamedicProfession = (props: ParamedicProfessionProps): ReactElement => {
   return (
      <StyledRolesText testId={'paramedicProfession'}>
         <Translate>
            {
               calendarTranslationKeys.practitioner.paramedicalProfessions[
                  props.profession as PractitionerAvailableProfessionType
               ]
            }
         </Translate>
      </StyledRolesText>
   );
};
